const mobileFiltersBtn = () => {
    const mobileFilters = document.querySelector('.filters');
    if (!mobileFilters) return;

    const mobileFiltersHolder = mobileFilters.querySelector('.mobile-holder');
    const mobileFiltersBtn = mobileFilters.querySelector('.filters-mobile-btn');

    if (!mobileFiltersBtn || !mobileFiltersHolder) return;

    mobileFiltersBtn.addEventListener('click', () => {
        const isOpen = mobileFilters.classList.contains('showed');

        if (isOpen) {
            mobileFilters.classList.remove('showed');
            mobileFiltersHolder.style.height = '0px';
        } else {
            mobileFilters.classList.add('showed');

            mobileFiltersHolder.style.height = 'auto';
            const realHeight = mobileFiltersHolder.offsetHeight;
            mobileFiltersHolder.style.height = '0px';

            void mobileFiltersHolder.offsetWidth;

            mobileFiltersHolder.style.height = realHeight + 'px';
        }
    });
};

export default mobileFiltersBtn;